import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { toggleCart, fetchCart, clearCart, removeFromCart } from '../../actions';
import { getHeaderType, getPrettyPrice, getTaxAmount, ShopifyClient } from '../../helpers';
import CartVideo from './CartVideo';
import classNames from 'classnames';
import Shopify from 'shopify-buy';

const CartRow = ({product, onMouseEnter, onMouseLeave, onRemove}) => {

  return (
    <tr onMouseEnter={e => onMouseEnter(e)} onMouseLeave={e => onMouseLeave(e)}>
      <td>
        <div className="remove" onClick={() => onRemove(product)}>⨯</div>
        {product.attributes.productTitle} ({product.attributes.variantTitle})
      </td>
      <td>{product.quantity || 'NaN'}</td>
      <td>{getPrettyPrice(product.attributes.price)}</td>
      <td>{getPrettyPrice(parseInt(product.quantity) * parseFloat(product.attributes.price)) || 'NaN'}</td>
    </tr>
  )
}
const Cart = props => {
  const activeRef = useRef();
  const [ hovered, setHovered ] = useState(false);
  const [ isCheckingOut, setIsCheckingOut ] = useState(false);

  useEffect(() => {
    activeRef.current = props.active;
  }, [props.active])

  useEffect(() => {
    props.fetchCart();
    const initialHeaderType = getHeaderType();
    window.addEventListener('keydown', _handleKeyPress);

    return function cleanup(){
      window.removeEventListener('keydown', _handleKeyPress);
    }
  }, []);

  const _handleCheckoutClick = () => {
    setIsCheckingOut(true);

    let lineItems = [];

    Object.keys(props.products).map((key, i) => {
      const product = props.products[key][0];

      lineItems.push({
        variantId: product.id,
        quantity: product.quantity
      });
    });

    ShopifyClient.checkout.create().then((checkout) => {
      ShopifyClient.checkout.addLineItems(checkout.id, lineItems).then((checkout) => {
        props.clearCart();
        window.location.href = checkout.webUrl;
      });
    });
  }

  const _handleKeyPress = e => {
    if(activeRef.current && e.code === 'Escape'){
      props.toggleCart();
    }
  }

  const _handleMouseEnter = e => setHovered(true);
  const _handleMouseLeave = e => setHovered(false);

  return (
    <div className={classNames('cart', {
      'cart--active': props.active && props.quantity > 0,
      'cart--loading': isCheckingOut
    })}>
      <div className="cart__content">
        <div className="cart__title">
          Cart
        </div>

        <table className={classNames({'hovered': hovered})}>
          <tbody>
            <tr>
              <th>Description</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
            {props.products && Object.keys(props.products).map((key, i) => {
              const product = props.products[key][0];

              return <CartRow
                key={i}
                product={product}
                onMouseEnter={e => _handleMouseEnter(e)}
                onMouseLeave={e => _handleMouseLeave(e)}
                onRemove={() => props.removeFromCart(product.attributes.variantId)}
                />
            })}
          </tbody>
        </table>
        <hr />
        <div className="summary">
          <div className="row">
            <div>Summary</div>
            <div>{getPrettyPrice(parseFloat(props.total - getTaxAmount(props.total)))}</div>
          </div>
          <div className="row">
            <div>Tax (19%)</div>
            <div>+ {getPrettyPrice(getTaxAmount(props.total))}</div>
          </div>
          <div className="row highlight">
            <div>Total</div>
            <div>{getPrettyPrice(props.total)}</div>
          </div>
        </div>
        <button className="button checkout" onClick={() => _handleCheckoutClick()}>
          {isCheckingOut ?
            <span>Checking out…</span>
            :
            <span>Purchase</span>
          }
        </button>
        <small>
          We know shopping carts can be quite boring, thats why we put up a little entertainment for you.
        </small>
      </div>
      <CartVideo />
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    active: state.cart.active,
    products: state.cart.products,
    quantity: state.cart.quantity,
    total: state.cart.total,
    loading: state.cart.loading,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    removeFromCart: product => {
      dispatch(removeFromCart(product));
    },
    fetchCart: () => {
      dispatch(fetchCart());
    },
    toggleCart: () => {
      dispatch(toggleCart());
    },
    clearCart: () => {
      dispatch(clearCart());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
